import { ActModuleStoreNavigation } from '../reducers/ActModuleReducer'
import { ACT_MODULE_NAVIGATION_TOGGLE, ACT_MODULE_FINISH_TOGGLE } from './types'

export const toggleActModuleNavigation = (state: ActModuleStoreNavigation) => (dispatch: any) => {
    dispatch({
        type: ACT_MODULE_NAVIGATION_TOGGLE,
        payload: state,
    })
}

export const toggleActModuleFinish = (state: boolean) => (dispatch: any) => {
    dispatch({
        type: ACT_MODULE_FINISH_TOGGLE,
        payload: state,
    })
}
